import type { PasskeyCredential, VaultPayload } from "../vaultPayload.js";

/** What the UI shows about a website passkey. Nothing here signs: no private key, no user handle. */
export interface PasskeyInfo {
  /** The relying party id, e.g. `github.com`. */
  readonly site: string;
  /** The site's own name, only when it says more than the id. */
  readonly siteName: string | undefined;
  /** The account name at the site; the display name when the site gave none. Empty when neither exists. */
  readonly user: string;
  /** The display name, only when it differs from `user`. */
  readonly displayName: string | undefined;
  readonly createdAt: number | undefined;
  /** Shortened credential id, enough to tell two passkeys of the same site apart. */
  readonly shortId: string;
}

/** Only login items carry a website passkey. */
export function hasPasskey(data: VaultPayload): boolean {
  return data.type === "login" && data.passkey !== null;
}

export function shortCredentialId(id: string): string {
  return id.length <= 12 ? id : `${id.slice(0, 6)}…${id.slice(-4)}`;
}

export function describePasskey(passkey: PasskeyCredential): PasskeyInfo {
  const user = passkey.userName !== "" ? passkey.userName : passkey.userDisplayName;
  const created = Date.parse(passkey.createdAt);
  const rpName = passkey.rpName.trim();
  return {
    site: passkey.rpId,
    siteName: rpName === "" || rpName.toLowerCase() === passkey.rpId.toLowerCase() ? undefined : rpName,
    user,
    displayName: passkey.userDisplayName === "" || passkey.userDisplayName === user ? undefined : passkey.userDisplayName,
    createdAt: Number.isNaN(created) ? undefined : created,
    shortId: shortCredentialId(passkey.credentialId)
  };
}
